import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import {
    ONBOARDING_AGENT_PANEL_EXPANDED_HEIGHT_OFFSET,
    ONBOARDING_AGENT_PANEL_HEIGHT,
    ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS,
    ONBOARDING_AGENT_PANEL_WIDTH,
} from "../OnboardingAgent/constants";

const EXPANDED_HEIGHT = `max(${ONBOARDING_AGENT_PANEL_HEIGHT}px, calc(100vh - ${ONBOARDING_AGENT_PANEL_EXPANDED_HEIGHT_OFFSET}px))`;

export const PanelRoot = styled(Flex)<{ readonly $isExpanded?: boolean }>`
    box-sizing: border-box;
    width: ${ONBOARDING_AGENT_PANEL_WIDTH}px;
    height: ${({ $isExpanded }) => ($isExpanded ? EXPANDED_HEIGHT : `${ONBOARDING_AGENT_PANEL_HEIGHT}px`)};
    overflow: hidden;
    border-radius: 16px;
    background-color: ${colorsPalettes.carbon[0]};
    transition: height ${ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
    ${setElevation("Z3")}
`;

export const HeaderLead = styled(Flex)`
    align-items: center;
    gap: 5px;
    height: 100%;
    flex: 1;
    min-width: 0;
`;

export const ChatHeader = styled(Flex)`
    box-sizing: border-box;
    flex-shrink: 0;
    height: 48px;
    align-items: center;
    justify-content: space-between;
    padding: 8px 4px 8px 12px;
    border-bottom: 1px solid ${colorsPalettes.blue[100]};
    background-color: ${colorsPalettes.sky[100]};
`;

export const HeaderTitle = styled(Text)`
    letter-spacing: 0.2px;
`;

export const HeaderActions = styled(Flex)`
    align-items: center;
    flex-shrink: 0;
`;

export const HeaderActionButton = styled(Button)`
    && {
        min-width: 32px;
        padding: 0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    svg {
        flex-shrink: 0;
    }
`;

export const ChatBody = styled(Flex)`
    box-sizing: border-box;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    gap: 16px;
    padding: 5px 0 16px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const ChatBodyMain = styled(Flex)`
    flex: 1;
    min-height: 0;
    flex-direction: column;
    overflow-y: auto;
    padding: 19px 16px 0;
`;

export const ChatBodyScrollSpacer = styled.div`
    flex: 0 0 auto;
    width: 100%;
    height: 0;
`;
